import script from "./approval-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./approval-form.vue?vue&type=script&setup=true&lang=ts"

import "./approval-form.vue?vue&type=style&index=0&id=3ea3d0ce&lang=css"

const __exports__ = script;

export default __exports__